import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=c2c116a4&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "./Info.vue?vue&type=style&index=0&id=c2c116a4&lang=stylus&scoped=true&"
import style1 from "./Info.vue?vue&type=style&index=1&id=c2c116a4&lang=stylus&scoped=true&"
import style2 from "./Info.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c116a4",
  null
  
)

export default component.exports